import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class RequiredServiceQualElementService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'RequredServiceQualificationElement/';
  // fetch all RequiredServiceQualElement in the database
  allData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getRequiredServiceQualElement(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getRequiredServiceQualElementByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postRequiredServiceQualElement(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteRequiredServiceQualElement(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateRequiredServiceQualElement(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
